export default __webpack_public_path__ + "static/media/hht2_ep5_speaking_03.f4eb4950.png";